// Constants
import { InteractionRequiredAuthError, InteractionRequiredAuthErrorCodes } from "@azure/msal-browser-1p";
import { Constants } from "@azure/msal-common-uno";
/**
 * Indicates whether the given error is an InteractionRequiredAuthError with login_required or interaction_required error code
 * @param error Error to check
 * @returns True if the error is a login required auth error, false otherwise
 */ export function isLoginRequiredAuthError(error) {
    const errorCode = error?.errorCode;
    return error !== undefined && error instanceof InteractionRequiredAuthError && (errorCode === InteractionRequiredAuthErrorCodes.loginRequired || errorCode === InteractionRequiredAuthErrorCodes.interactionRequired || errorCode === InteractionRequiredAuthErrorCodes.consentRequired || errorCode === Constants.INVALID_GRANT_ERROR);
}
